import React, { useEffect, useState } from "react";
import { submiterror } from "./SubmitProm";
import base64convertor from "../converterfunction";
import { getobj_byid } from "../Api/api";
export default function Formd(prop) {
  console.log(prop.prop);
    var [databoj,setdataboj]=useState([]);
    console.log(Object.keys(prop).length,prop.prop);
    async function caller()
    {
        if (Object.keys(prop).length){
            var {data} = await getobj_byid(prop.prop);
            console.log(data[0]);
            setdataboj(data[0]);
        } 
        else{
            console.log("this is not a edit page or else we get an error");
        }
    }
    useEffect(()=>{
        caller();
    },[])
    
      var list_obj = ["Title", "Public", "Username", "Type", "Description"];
    var list = ["All", "Tech", "DailyPost"];
  var default_obj = {
    Title: "",
    Public: "",
    Username: "",
    All: "",
    Tech: "",
    DailyPost: "",
    Description: "",
    imgurl: "",
  };

    var [img_, setimg] = useState({ value: "" });
  var [allstates, setallstates] = useState(default_obj);

    async function bgseter(e) {
      console.log(e.target.files[0]);
      // var parent = e.target.parentNode;
      // console.log(parent.childNodes);
      var file = e.target.files[0];
      var bg = await base64convertor(file);
      setimg({ value: bg });
      console.log(img_);
      setallstates({ ...allstates, imgurl: bg });
      console.log(allstates);
      // console.log(bg);

      // parent.style.background = `url${bg}`;
    }
    function onchangehandler(e) {
      // console.log(e.target.name, e.target.value);
      setallstates({ ...allstates, [e.target.name]: e.target.value });
      console.log(allstates);
    }
  return (
    <div className="form_data">
      <div className="image_upload">
        {img_.value ? (
          <img src={img_.value} id="first_one" />
        ) : databoj ? (
          <img id="first_one" src={databoj.imgurl} />
        ) : (
          <img id="first_one" />
        )}
        <input id="inp1" type="file" onChange={bgseter} />
        <h1 id="h_1">Or</h1>
        <input
          id="inp2"
          type="text"
          onChange={(e) => {
            setimg({ value: e.target.value });
            setallstates({ ...allstates, imgurl: e.target.value });
          }}
        />
      </div>
      <div className="forminsdata">
        {list_obj.map((e, i) => {
            console.log(e);
          if (i !== 3 && i !== 4) {
            return (
              <div id={`__${i}div`} className="formdiv" key={i}>
                <label id="lbl">{e} </label>
                <input
                  id={`__${i}`}
                  name={e}
                  placeholder={
                    e === "Title"
                      ? Object.keys(databoj).length
                        ? databoj.Title
                        : "Title"
                      : e === "Username"
                      ? Object.keys(databoj).length
                        ? databoj.Username
                        : "Username"
                      : e === "Public"
                      ? Object.keys(databoj).length
                        ? databoj.Public
                        : "Public"
                      : e === "Description"
                      ? Object.keys(databoj).length
                        ? databoj.Description
                        : "Description"
                      : "Description"
                  }
                  
                  className="finsinp"
                  onChange={onchangehandler}
                />
              </div>
            );
          } else if (i === 4) {
            return (
              <div id={`__${i}div`} className="formdiv" key={i}>
                <label id="lbl">{e} </label>
                <textarea
                  onChange={onchangehandler}
                  id={`__${i}`}
                  name={e}
                  placeholder={
                    e === "Title"
                      ? Object.keys(databoj).length
                        ? databoj.Title
                        : "Title"
                      : e === "Username"
                      ? Object.keys(databoj).length
                        ? databoj.Username
                        : "Username"
                      : e === "Public"
                      ? Object.keys(databoj).length
                        ? databoj.Public
                        : "Public"
                      : e === "Description"
                      ? Object.keys(databoj).length
                        ? databoj.Description
                        : "Description"
                      : "Description"
                  }
                  className="finsinp"
                />
              </div>
            );
          } else {
            return (
              <div id={`__${i}div`} className="formdiv" key={i}>
                <label id="lbl">{e} </label>
                <div id={`__${i}`}>
                  {list.map((e, i) => {
                    return (
                      <div className="same_instance" key={i}>
                        {e}:
                        <input
                          onChange={onchangehandler}
                          name={e}
                          type="checkbox"
                        />
                      </div>
                    );
                  })}
                </div>
              </div>
            );
          }
        })}
        <button
          onClick={async (e) => {
            console.log(e.target);
            console.log(allstates);
            try {
              var value = await submiterror(e, allstates, databoj, prop.prop);
              console.log(value);
            } catch (err) {
              console.log(err);
            }
          }}
          id="btn"
        >
          Submit Data
        </button>
      </div>
    </div>
  );
}
